export default "/images/tevalis.png?73db18a05c14a1ba95be819c8458fa28";